<p-dialog
	*ngIf="subscriptionItem"
	[(visible)]="subscriptionItem"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
	(onHide)="subscriptionItemChange.emit(undefined); bulkEditChange.emit(false)"
	[closable]="false"
>
	<form #subscriptionItemForm="ngForm">
		<div class="p-grid">
			<div class="p-col-12 d-flex">
				<div class="my-auto me-2">Active</div>
				<p-inputSwitch name="subscriptionItemActiveSwitch" [(ngModel)]="!subscriptionItem.inactive"></p-inputSwitch>
			</div>
		</div>
		<div class="p-grid mt-4">
			<div class="p-col-12 p-md-6">
				<span class="p-float-label mt-2 w-100">
					<p-dropdown
						required
						#subscriptionItemMenuItemKey
						[options]="customerService.venueService.ooMenuItems"
						optionLabel="name"
						optionValue="menuItemKey"
						name="subscriptionItemMenuItemKey"
						[(ngModel)]="subscriptionItem.menuItemKey"
						[style]="{ width: '100%' }"
						(ngModelChange)="setItem()"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						filterBy="name"
					>
					</p-dropdown>
					<label for="subscriptionItemMenuItemKey">Menu Item</label>
				</span>
			</div>
			<div class="p-col-12 p-md-6">
				<span class="p-float-label mt-2 w-100">
					<p-dropdown
						required
						#subscriptionItemMenuItemPriceNumber
						[disabled]="!subscriptionItem.menuItemKey && !subscriptionItem.ooMenuItem"
						[options]="customerService.venueService.menuItemPriceOptions(subscriptionItem.ooMenuItem)"
						optionLabel="label"
						optionValue="value"
						name="subscriptionItemMenuItemPriceNumber"
						[(ngModel)]="subscriptionItem.priceNumber"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
					>
					</p-dropdown>
					<label for="subscriptionItemMenuItemPriceNumber">Price</label>
				</span>
			</div>
		</div>
		<div class="p-grid mt-2">
			<div class="p-col-12 p-md-6">
				<span class="p-float-label mt-2 w-100">
					<p-dropdown
						required
						#subscriptionItemFrequency
						[options]="customerService.venueService.subscriptionFrequencyOptions()"
						optionLabel="label"
						optionValue="value"
						name="subscriptionItemFrequency"
						[(ngModel)]="subscriptionItem.frequency"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
					>
					</p-dropdown>
					<label for="subscriptionItemFrequency">Frequency</label>
				</span>
			</div>
			<div class="p-col-12 p-md-6">
				<span class="p-float-label mt-2 w-100">
					<p-dropdown
						[disabled]="bulkEdit"
						#subscriptionItemToken
						[options]="customerService.customer.value.tokens"
						optionLabel="displayName"
						optionValue="token"
						name="subscriptionItemToken"
						[(ngModel)]="subscriptionItem.token"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
					>
					</p-dropdown>
					<label for="subscriptionItemToken">Credit Card</label>
				</span>
			</div>
		</div>
		<div class="p-grid mt-2">
			<div class="p-col-12 p-md-6">
				<span class="p-float-label mt-2 w-100">
					<p-calendar
						required
						#subscriptionItemNextBillDate
						name="subscriptionItemNextBillDate"
						[(ngModel)]="subscriptionItem.nextBillDateDate"
						styleClass="w-100"
						[minDate]="app.moment().toDate()"
						(onSelect)="subscriptionItem.nextBillDate = app.moment(subscriptionItem.nextBillDateDate).unix()"
						appendTo="body"
					>
					</p-calendar>
					<label for="subscriptionItemLastBillDate">Next Billing Date</label>
				</span>
			</div>
			<div class="p-col-12 p-md-6">
				<div class="d-flex flex-fill w-100 mt-2">
					<p-checkbox
						[disabled]="bulkEdit"
						name="deliveryOption"
						binary="true"
						[(ngModel)]="subscriptionItem.delivery"
						label="Delivery"
						labelStyleClass="me-2"
					></p-checkbox>
					<span class="p-float-label w-100">
						<p-dropdown
							#deliveryAddressSelect
							[disabled]="!subscriptionItem.delivery"
							[options]="customerService.customer.value.addresses"
							optionLabel="displayName"
							optionValue="street1"
							name="deliveryAddressSelect"
							[(ngModel)]="subscriptionItem.deliveryAddressKey"
							styleClass="w-100"
							appendTo="body"
							[autoDisplayFirst]="false"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							filter="true"
							filterBy="filterByProperties"
						></p-dropdown>
						<label for="deliveryAddressSelect">Delivery Address</label>
					</span>
				</div>
			</div>
		</div>
	</form>

	<app-record-control-footer
		(onCancelChange)="subscriptionItemChange.emit(undefined); bulkEditChange.emit(false)"
		(onSaveChange)="onSave()"
		[saveDisabled]="subscriptionItemForm.invalid"
		[deleteDisabled]="!bulkEdit"
		(onDeleteChange)="onDelete()"
		[deleteDisabled]="!subscriptionItem.sk"
	>
	</app-record-control-footer>
</p-dialog>
